<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <div class="about">
        <page :url="url" :dataList.sync="dataList" :form="form">
          <template slot="tableSearch">
            <el-form-item label="角色代码" prop="code">
              <el-input v-model="form.code" placeholder="角色代码"></el-input>
            </el-form-item>
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="form.name" placeholder="角色名称"></el-input>
            </el-form-item>
            <el-form-item label="是否锁定" prop="isLocked">
              <el-select v-model="form.isLocked" placeholder="是否锁定">
                <el-option label="请选择" value=""></el-option>
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </template>

          <template slot="buttonArea">
            <el-button type="primary" @click="addRole" size="small"
              >添加用户</el-button
            >
          </template>
          <template slot="tableColumn">
            <el-table-column prop="id" align="center" label="编号">
            </el-table-column>
            <el-table-column prop="code" align="center" label="角色代码">
            </el-table-column>
            <el-table-column prop="name" align="center" label="角色名称">
            </el-table-column>
            <el-table-column prop="createUser" align="center" label="创建用户">
            </el-table-column>
            <el-table-column
              prop="isLocked"
              align="center"
              :formatter="$formatter.formatBoolean"
              label="是否锁定"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              align="center"
              :formatter="$formatter.formatDate"
              label="创建时间"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              align="center"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="roleEdit(scope.$index, scope.row)"
                  >编辑
                </el-button>
              </template>
            </el-table-column>
          </template>
        </page>
        <system_role_edit
          :show.sync="showAddUserDialog"
          :value="value"
        ></system_role_edit>
      </div>
    </div>
  </div>
</template>
<script>
import Page from "../../components/Page.vue";
import SystemRoleEdit from "../../components/auth/SystemRoleEdit.vue";

export default {
  components: {
    page: Page,
    system_role_edit: SystemRoleEdit,
  },
  data() {
    return {
      form: {
        code: "",
        name: "",
        isLocked: "",
        systemId: "",
      },
      url: "/sysRoleInfo/selectList",
      dataList: [], //双向绑定获取数据
      spanArr: [],
      showAddUserDialog: false,
      value: null,
      systemList: [],
    };
  },
  methods: {
    formatRole: function (row, column) {
      return row.isLocked ? "是" : "否";
    },
    roleEdit(index, row) {
      console.log(index, row);

      let isLocked = row.isLocked ? "1" : "0";
      console.log(isLocked);

      let obj = {};
      obj.roleName = row.name;
      obj.isLocked = isLocked;
      obj.code = row.code;
      obj.id = row.id;
      obj.systemId = row.systemId;
      obj.systemName = row.systemName;
      this.value = obj;
      this.showAddUserDialog = true;
    },
    addRole(row) {
      this.value = {};
      this.action = "addRole";
      this.formData = row;
      this.showAddUserDialog = true;
    },
  },
  created() {},
};
</script>
<style scoped>
</style>